// @ts-nocheck
import { CASE_REQUIRED_LIST_ERROR, CASE_REQUIRED_LIST_LOADING, CASE_REQUIRED_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseRequiredListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_REQUIRED_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_REQUIRED_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_REQUIRED_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

